_sectionStatus